import React from "react";
import { Autocomplete, InputLabel, Stack } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { StyledAutocompletePopper, StyledBox, StyledTextField, StyledTypography } from "../style.module";
import { Controller, useFormContext } from "react-hook-form";

const FormSelect = ({
  name,
  elementId,
  inputLabel,
  isRequired,
  isMultiSelect,
  data = [],
  isDisabled
}) => {
  const master_data = Array.isArray(data) ? data : [];
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Stack>
      <InputLabel htmlFor={elementId}>
        <StyledBox>
          {isRequired && (
            <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "red" }}>
              *
            </StyledTypography>
          )}
          <StyledTypography variant="subtitle2" gutterBottom typostyle={{ color: "#000000", fontSize: "0.8rem" }}>
            {inputLabel}
          </StyledTypography>
        </StyledBox>
      </InputLabel>

      <Controller
        control={control}
        name={name}
        defaultValue={isMultiSelect ? [] : null}
        render={({ field }) => (
          <Autocomplete
            {...field}
            disableClearable={!isMultiSelect && isRequired}
            disabled={isDisabled}
            PopperComponent={StyledAutocompletePopper}
            multiple={isMultiSelect}
            id={elementId}
            size="small"
            options={master_data}
            value={field.value || (isMultiSelect ? [] : null)}
            getOptionLabel={(option) => (option ? String(option.label) : "")}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            onChange={(_, value) => {
              if (isMultiSelect) {
                // For multi-select, value is an array
                field.onChange(value || []); // Ensure empty array if no value selected
              } else {
                // For single-select, value is a single object
                field.onChange(value || null);
              }
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{option.label}</span>
                {selected && <CheckIcon style={{ color: "black" }} fontSize="small" />}
              </li>
            )}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                variant="outlined"
                error={!!errors[name]}
                placeholder={
                  !field.value || (Array.isArray(field.value) && field.value.length === 0)
                    ? inputLabel
                    : ""
                }
                helperText={errors[name] ? errors[name].message : ""}
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    overflowY: "hidden",
                    scrollbarWidth: "thin",
                    "&::-webkit-scrollbar": {
                      height: "4px",
                    },
                    '& .MuiAutocomplete-endAdornment': {
                      position: 'absolute',
                      right: 8,
                      top: 'calc(50% - 12px)', // Center the icons vertically
                      zIndex: 1,
                    },
                    '& .MuiAutocomplete-inputRoot': {
                      paddingRight: '60px', // space for dropdown and clear icon
                      flexWrap: 'wrap', // allow chips to wrap
                    },
                    '& .MuiAutocomplete-tag': {
                      maxWidth: '100%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  },
                  backgroundColor: isDisabled ? "rgba(0, 0, 0, 0.06)" : "white", // Greyed out background when disabled
                }}
              />
            )}
          />
        )}
      />
    </Stack>
  );
};

export default FormSelect;
